'use client';
import react from "react";
const INBOX_LOCATION_VALUE = 'message_inbox';
const useInbox = (refreshInboxInterval = 5000)=>{
    const [unreadOffersCount, setUnreadOffersCount] = react.useState(0);
    const [pollForBrazeId, setPollForBrazeId] = react.useState(void 0);
    const [brazeClient, setBrazeClient] = react.useState();
    const updateUnreadOffers = ()=>{
        if (brazeClient) {
            const onSuccess = ()=>{
                const allCards = brazeClient.getCachedContentCards().cards;
                const numberOfNotifications = allCards.filter((offer)=>!offer.viewed && offer.extras.location === INBOX_LOCATION_VALUE).length;
                setUnreadOffersCount(numberOfNotifications);
            };
            brazeClient.requestContentCardsRefresh(onSuccess);
        }
    };
    setTimeout(()=>{
        clearInterval(pollForBrazeId);
    }, 25000);
    react.useEffect(()=>{
        if (!pollForBrazeId) setPollForBrazeId(setInterval(()=>{
            if (!brazeClient && 'undefined' != typeof window && window.braze) {
                setBrazeClient(window.braze);
                clearInterval(pollForBrazeId);
            }
        }, 1000));
    }, [
        brazeClient,
        pollForBrazeId
    ]);
    react.useEffect(()=>{
        if (brazeClient) {
            const intervalId = setInterval(updateUnreadOffers, refreshInboxInterval);
            return ()=>clearInterval(intervalId);
        }
    }, [
        brazeClient,
        pollForBrazeId
    ]);
    return {
        unreadOffersCount
    };
};
export { useInbox };
